import { defaultLocale } from '../../settings';
import { LanguageDirection } from '../enums/LanguageDirection';

const LANGUAGE_SETTINGS = 'fo:language_settings';
const defaultDirection = LanguageDirection.LTR;

/**
 * Retrieve the current language setting from local storage
 */
export const getLanguageSettings = () => {
  const settings = JSON.parse(localStorage.getItem(LANGUAGE_SETTINGS) ?? '{}');
  return {
    language: settings.language || defaultLocale,
    direction: settings.direction || defaultDirection,
  };
};

/**
 * Set the current language setting in local storage
 */
export const setLanguageSettings = (settings) => {
  localStorage.setItem(LANGUAGE_SETTINGS, JSON.stringify(settings));
};
